export default "__VITE_ASSET__BB32WJWU__"